export default function getResource(label, vars = []) {
    const resources = {
        reviewsLabel: `${vars[0]}`,
        writeReview: 'Write a review',
        ratingsReviews: 'Reviews Summary',
        seeAllReviews: 'See all reviews',
        closeButton: 'Close'
    };
    return resources[label];
}
